module.exports = __webpack_public_path__ + "static/media/jovana-arsic.116d533c.jpg";